"use client";

import { ReactNode } from "react";
import { Text } from "@leabankab/component-library";

type Props = {
	children?: ReactNode;
	tone?: "error" | "success";
};

export const StepErrorMessage = ({ children, tone = "error" }: Props) => {
	if (!children) {
		return null;
	}

	return (
		<Text
			render={<p />}
			textStyle="body-sm"
			color={
				tone === "success" ? "status.success.base" : "status.error.base"
			}
			role="alert"
		>
			{children}
		</Text>
	);
};
